module.exports = __webpack_public_path__ + "static/media/marca.1e9faa71.svg";